import { useAppDispatch, useAppSelector } from 'src/redux/hook';
import { setGlobalState } from 'src/redux/slice/globalSlice';
import { TransactionHistoryType } from 'src/shared/enum/localpay';
import { TransactionHistory } from 'src/shared/interface/localpay.interface';

interface UseOpenMenuTabParams {
  selectedHistory: TransactionHistory;
}

interface TabInfo {
  url: string;
  label: string;
}

export const useOpenMenuTab = () => {
  const dispatch = useAppDispatch();
  const { openTabs } = useAppSelector((state) => state.global);

  const getTabInfo = (type: string): TabInfo => {
    switch (type) {
      case TransactionHistoryType.RegisterPackage:
        return {
          url: 'order-assigned-package/detail',
          label: 'Xem chi tiết Gán gói',
        };
      case TransactionHistoryType.CancelPackage:
        return {
          url: 'register-and-cancel-and-load-package/cancel/detail',
          label: 'Xem chi tiết Hủy gói',
        };
      case TransactionHistoryType.InitiatePackage:
        return {
          url: 'register-and-cancel-and-load-package/register/detail',
          label: 'Xem chi tiết Đăng ký gói',
        };
      case TransactionHistoryType.Datacode:
        return {
          url: 'register-and-cancel-and-load-package/data-load/detail',
          label: 'Xem chi tiết Nạp data',
        };
      case TransactionHistoryType.EnterpriseTopup:
        return {
          url: 'topup/detail',
          label: 'Xem chi tiết Nạp tiền',
        };
      default:
        return {
          url: 'changeSim/createChangeSim',
          label: 'Xem chi tiết Đổi sim',
        };
    }
  };

  const openMenuTab = ({ selectedHistory }: UseOpenMenuTabParams) => {
    if (!selectedHistory) return;

    const { url, label } = getTabInfo(selectedHistory.type);
    const id = selectedHistory.paymentId || selectedHistory.id;
    const fullUrl = `${url}?id=${id}`;
    const tabLabel = `${label} ${id}`;

    // Check if tab already exists to avoid duplicates
    const existingTab = openTabs.find((tab) => tab.key === fullUrl);
    if (existingTab) {
      // Just set active key if tab already exists
      dispatch(setGlobalState({ activeKeyMenu: fullUrl }));
      return;
    }

    // Set active menu key
    dispatch(setGlobalState({ activeKeyMenu: fullUrl }));

    // Add new tab
    dispatch(
      setGlobalState({
        openTabs: [
          ...openTabs,
          {
            label: tabLabel,
            children: '',
            key: fullUrl,
            closable: true,
          },
        ],
      }),
    );
  };

  return { openMenuTab };
};
